<div class="card mb-4 shadow-sm" *ngFor="let category of categories|keyvalue">
    <div class="card-header p-3 cursor-pointer d-flex justify-content-between" (click)="category.value.expanded = !category.value.expanded">
        <div>{{category.key}} <small class="text-muted">{{category.value.list.length}} portfolios</small></div>

      <div class="d-flex flex-row">
          <div *ngIf="category.value.expanded">
            <mat-form-field class="sort-select">
              <mat-select [(ngModel)]="sorting" (ngModelChange)="onSortingChange()" placeholder="Sort" (click)="$event.stopPropagation()">
                <mat-option *ngFor="let s of sortOptions" [value]="s">{{s.name}}</mat-option>
              </mat-select>
              <button *ngIf="sorting" color="primary" mat-icon-button matSuffix (click)="sorting = null; onSortingChange(); $event.stopPropagation()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div>
            <span class="text-primary">
            {{category.value.expanded ? 'Hide content' : 'Show content'}}
              <mat-icon class="align-bottom">{{category.value.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
        </span>
          </div>
        </div>
    </div>
    <div class="card-body portfolio-list-container p-0" [@detailExpand]="category.value.expanded ? 'expanded' : 'collapsed'">
        <div *ngFor="let portfolio of category.value.list" class="portfolio-card px-3 py-1">
            <div *ngIf="portfolio.status === 2">
              <!-- Computation failed -->
              <span class="cursor-pointer underline-on-hover" (click)="onStockClick(portfolio)">{{portfolio.name}}</span>
              <p class="not-ready-text text-danger" [matTooltip]="portfolio.status_text || 'Computation failed'">
                <mat-icon class="align-middle" style="font-size: 16px; width: 16px; height: 16px; color: #d32f2f;">error</mat-icon>
                Computation failed - click to edit constraints
              </p>
            </div>
            <div *ngIf="portfolio.status !== 3 && portfolio.status !== 2">
              <!-- Not ready yet -->
              <span>{{portfolio.name}}</span>
              <p class="not-ready-text">Not ready yet</p>
            </div>

          <div class="row" *ngIf="portfolio.status === 3">
            <!-- Finished -->
            <div class="col-md-6">
              <div class="portfolio-title">
                <span class="cursor-pointer underline-on-hover" (click)="onStockClick(portfolio)">{{portfolio.name}}</span>
                <app-info-popover *ngIf="portfolio.description" [company]="portfolio" [title]="'Description - ' + portfolio.name" [content]="portfolio.description" (click)="closeOtherInfo(portfolio)"></app-info-popover>
                <div *ngIf="portfolio.shared_with_users_concat" [matTooltip]="'Shared with: ' + portfolio.shared_with_users_concat" class="shared-marker">
                  <mat-icon  class="cursor-pointer align-middle">group</mat-icon> Shared
                </div>
              </div>
              <div matTooltip="Weight" class="portfolio-stat d-inline-block"><mat-icon >balance</mat-icon> {{portfolio.weighting_type}}</div>
              <div matTooltip="Currency" class="portfolio-stat d-inline-block"><mat-icon >attach_money</mat-icon> {{portfolio.currency.code}}</div>
              <div matTooltip="Number of securities" class="portfolio-stat d-inline-block"><mat-icon>work</mat-icon>{{portfolio.security_count}}</div>
              <div matTooltip="Rebalancing" class="portfolio-stat d-inline-block"><mat-icon >display_settings</mat-icon>{{portfolio.rebalancing_type}}</div>
              <div matTooltip="Risk ( vol)" class="portfolio-stat d-inline-block"><mat-icon>warning</mat-icon>{{portfolio.risk}}%</div>
              <div matTooltip="Return" class="portfolio-stat d-inline-block"><mat-icon >signal_cellular_alt</mat-icon>{{portfolio.return}}%</div>
              <div matTooltip="ESG (Sustainability)" class="portfolio-stat d-inline-block"><mat-icon>recycling</mat-icon>{{portfolio.esg}}/10</div>
            </div>
            <div class="col-md-3">
              <app-line-chart [series]="[{data: portfolio.ytd_return_chart, name: portfolio.name}]" [extraOptions]="ytdOptions"></app-line-chart>
            </div>
            <div class="col-md-3">
              <button mat-icon-button class="float-end" [matMenuTriggerFor]="menu"><mat-icon class="color-mid-grey">more_vert</mat-icon></button>
              <mat-menu #menu="matMenu">
                <button *ngIf="!portfolio.readonly" mat-menu-item [routerLink]="['portfolio', portfolio.id]">Edit Portfolio</button>
                <button *ngIf="portfolio.readonly" mat-menu-item [routerLink]="['portfolio-view', portfolio.id]">View</button>
                <button mat-menu-item (click)="onClickCopy(portfolio)">Duplicate portfolio</button>
                <button *ngIf="!portfolio.readonly" mat-menu-item (click)="deleteItem(portfolio)">Delete</button>
                <button *ngIf="portfolio.readonly && portfolio.visibility == sharedVisivility" mat-menu-item (click)="unshareItem(portfolio)">Delete share</button>
              </mat-menu>
              <div class="portfolio-stat" matTooltip="Portfolio creation date"><mat-icon>calendar_month</mat-icon> {{portfolio.created_at | utcToLocalTime:'short'}}</div>
              <div class="portfolio-stat" matTooltip="Portfolio start date"><mat-icon>calendar_month</mat-icon> {{portfolio.start_date}}</div>
              <div class="portfolio-stat" matTooltip="Last portfolio edit"><mat-icon>sync</mat-icon> {{portfolio.updated_at | utcToLocalTime:'short'}}</div>
              <div class="portfolio-stat" matTooltip="Last data update"><mat-icon>sync</mat-icon> {{portfolio.last_updated_at | utcToLocalTime:'short'}}</div>
            </div>
          </div>

        </div>
    </div>
</div>
<div class="card mb-4 shadow-sm" *ngIf="!categories || !list || !list.length">
  <div class="card-body">
  <p class="m-0">No portfolios</p>
  </div>
</div>
